import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import styles from '../../styles.module.scss'

import { viewEvent } from '../../../utils'
import { action, serviceMap } from '../../../constants'
import { setServiceData } from '../../../../../../redux/billing/billing.action'

const ActivityTrackingHasExpired = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    viewEvent(action.hasExpired, serviceMap.activityTracking)

    return () => {
      // set the data: {} after checking the service event,
      // so that there is no function getServiceData call, it should be called once, when initializing the application
      dispatch(setServiceData({ service: serviceMap.activityTracking, data: {} }))
    }

    // eslint-disable-next-line
  }, [])

  return (
    <div className={styles.description}>
      <p className={styles.description_item}>Attention! Activity Tracking service subscription has expired.</p>
      <p>
        If you want to continue to see which companies are interested in your profile, please renew your subscription
      </p>
    </div>
  )
}

export default ActivityTrackingHasExpired
